import { DistributionTiming } from '../../domain/enums/distribution-timing';

export class StreetItemViewModel {
    public id: string;
    public streetId: string;
    public streetName: string;
    public houseNumbers: string;
    public polygon: string;
    public percentageComplete: number;
    public percentageCompleteEarly: number;
    public percentageCompleteLate: number;
    public distributionTiming: DistributionTiming;

    constructor();
    constructor(json: any);
    constructor(json?: StreetItemViewModel) {
        if (json) {
            this.id = json.id;
            this.streetId = json.streetId;
            this.streetName = json.streetName;
            this.houseNumbers = json.houseNumbers;
            this.polygon = json.polygon;
            this.percentageComplete = json.percentageComplete;
            this.percentageCompleteEarly = json.percentageCompleteEarly;
            this.percentageCompleteLate = json.percentageCompleteLate;
            this.distributionTiming = json.distributionTiming;
        }
    }

    public getAllProgress(): number {
        return this.percentageComplete + this.percentageCompleteEarly + this.percentageCompleteLate;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/view-models/street-item.view-model.ts